export const boostSocialRoute = '/employer/boosts/social/';
export const boostLocationRoute = '/employer/boosts/location/';
export const hiringGraphicRoute = '/employer/hiringgraphic/';
export const enterpriseGraphicRoute = '/enterprise/hiringgraphic/';
export const enterpriseBoostSocialRoute = '/enterprise/boosts/social/';
export const enterpriseBoostLocationRoute = '/enterprise/boosts/location/';
